import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import { Grid } from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import SearchIcon from "@material-ui/icons/Search";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListIcon from "@material-ui/icons/List";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import QueueMusicIcon from "@material-ui/icons/QueueMusic";
import AssessmentIcon from "@material-ui/icons/Assessment";
import ComputerIcon from "@material-ui/icons/Computer";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { TextField } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";

const useStyles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    marginRight: theme.spacing(1),
    height: "100%",
  },
  spaceBelow: {
    marginBottom: theme.spacing(2),
  },
  list: {
    width: "100%",
  },
  listIcon: {
    minWidth: "0px",
    marginRight: theme.spacing(4),
    "& .MuiSvgIcon-root": {
      fontSize: "1em",
    },
  },
  link: {
    color: theme.palette.text.primary,
    textDecoration: "none",
    width: "100%",
  },
});

class Sidebar extends React.Component {
  render() {
    const {
      classes,
      isOpen,
      toggleSidebarOpen,
      location,
      searchString,
      setSearchString,
    } = this.props;
    const { pathname } = location;

    return (
      <Card className={classes.root}>
        <Grid container>
          <Grid container item xs={12} justify="flex-end">
            <IconButton
              onClick={toggleSidebarOpen}
              className={classes.spaceBelow}
            >
              {isOpen ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
          </Grid>
          <List className={classes.list}>
            <Grid container item xs={12} justify="space-around">
              <Link
                to="/search"
                onClick={
                  pathname === "/search" ? (e) => e.preventDefault() : () => {}
                }
                className={classes.link}
              >
                <ListItem selected={pathname === "/search"}>
                  {isOpen ? (
                    <div />
                  ) : (
                    <ListItemIcon className={classes.listIcon}>
                      {<SearchIcon />}
                    </ListItemIcon>
                  )}
                  {isOpen ? (
                    <TextField
                      className={classes.spaceBelow}
                      size="small"
                      label="Search Spotify"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      value={searchString}
                      onChange={(e) => setSearchString(e.target.value)}
                    />
                  ) : (
                    <div />
                  )}
                </ListItem>
              </Link>
            </Grid>
            <Grid container item xs={12} justify="space-around">
              <Link
                to="/albums_to_rate"
                className={classes.link}
                onClick={() => setSearchString("")}
              >
                <ListItem
                  button
                  selected={pathname === "/albums_to_rate" || pathname === "/"}
                >
                  <ListItemIcon className={classes.listIcon}>
                    {<ListIcon />}
                  </ListItemIcon>
                  {isOpen ? (
                    <ListItemText primary={"Albums to Rate"} />
                  ) : (
                    <div />
                  )}
                </ListItem>
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                to="/playlists"
                className={classes.link}
                onClick={() => setSearchString("")}
              >
                <ListItem button selected={pathname === "/playlists"}>
                  <ListItemIcon className={classes.listIcon}>
                    {<QueueMusicIcon />}
                  </ListItemIcon>
                  {isOpen ? (
                    <ListItemText primary={"Playlist Builder"} />
                  ) : (
                    <div />
                  )}
                </ListItem>
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                to="/ratings"
                className={classes.link}
                onClick={() => setSearchString("")}
              >
                <ListItem button selected={pathname === "/ratings"}>
                  <ListItemIcon className={classes.listIcon}>
                    {<AssessmentIcon />}
                  </ListItemIcon>
                  {isOpen ? <ListItemText primary={"Ratings"} /> : <div />}
                </ListItem>
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                to="/tags"
                className={classes.link}
                onClick={() => setSearchString("")}
              >
                <ListItem button selected={pathname === "/tags"}>
                  <ListItemIcon className={classes.listIcon}>
                    {<LocalOfferIcon />}
                  </ListItemIcon>
                  {isOpen ? <ListItemText primary={"Tags"} /> : <div />}
                </ListItem>
              </Link>
            </Grid>
            <Grid item xs={12}>
              <Link
                to="/admin"
                className={classes.link}
                onClick={() => setSearchString("")}
              >
                <ListItem button selected={pathname === "/admin"}>
                  <ListItemIcon className={classes.listIcon}>
                    {<ComputerIcon />}
                  </ListItemIcon>
                  {isOpen ? <ListItemText primary={"Admin"} /> : <div />}
                </ListItem>
              </Link>
            </Grid>
          </List>
        </Grid>
      </Card>
    );
  }
}

export default withRouter(withStyles(useStyles)(Sidebar));
